import Vue from 'vue'
import Vuex from 'vuex'

import {getField, updateField} from 'vuex-map-fields'

Vue.use(Vuex)
export const store = new Vuex.Store({
    state:{
        securityAppName:'ReportView',
        securityAppItems:[],

        //general
        currentNav:'front',
        username:'',
        oldpassword:'',
        loggedInUser:{
            id:0,
            name:'',
        },
        loggedIn:false,
        logoOverride:'',
        configOverride:'',
        showHeader:true,

        //sched
        selectedResult:{'ID':0},
        selectedReport:null,
    },
    mutations:{
        updateField,
    },
    getters:{
        getField,
    },
    actions:{

    }
})